import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { Tree } from "@lhd/types";
import { getCompanyId } from "@lhd/utility";
import { notification } from "antd";

export const useFetchOrganizations = ({
  branchId,
  nameOnly,
}: {
  branchId?: number;
  nameOnly?: boolean;
}) => {
  const companyId = getCompanyId();
  return useQuery(
    [QUERY_NAME.ORGANIZATIONS, companyId, branchId, nameOnly],
    () =>
      axios({
        method: "get",
        url: `${SERVICES.COMPANIES}/${companyId}/tree`,
        params: {
          model_name: "organization",
          ...(branchId && { branch_id: branchId, with_base: true }),
          ...(nameOnly && { name_only: true }),
        },
      }).then((res) => (res.data as Tree[]) || []),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    },
  );
};

export const useUpdatePrefectures = () => {
  const companyId = getCompanyId();
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload, deleteIds, branch }: any) =>
      axios({
        method: "put",
        url: `${SERVICES.COMPANIES}/${companyId}/tree`,
        data: {
          data: {
            data: payload,
            delete_ids: deleteIds,
          },
        },
        params: {
          model_name: "organization",
          branch_id: branch === 0 ? null : branch,
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.ORGANIZATIONS]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};

// export const useFetchOrgs = () => {
//   return useQuery(
//     [QUERY_NAME.ORGS],
//     () =>
//       axios({
//         method: "get",
//         url: `${SERVICES.ORGS}`,
//       }).then((res) => (res.data as Tree[]) || []),
//     {
//       cacheTime: Infinity,
//       staleTime: Infinity,
//     },
//   );
// };
